// extracted by mini-css-extract-plugin
export default {"container":"PermissionErrModal_container__wDu+D","err-msg":"PermissionErrModal_err-msg__vk2NG","closeBtn":"PermissionErrModal_closeBtn__LRJtL"};